import React from 'react';
import { FormField, FormFieldLabel, CheckboxGroup, CheckboxOption } from 'styles/common.styles';

/**
 * Checkbox ?�???�드 컴포?�트
 * 
 * @param {Object} props
 * @param {string} props.name - ?�드 ?�름
 * @param {string} props.label - ?�드 ?�벨
 * @param {Array|string|boolean} props.value - ?�드 �?(배열 ?�는 ?�일 �?
 * @param {Array} props.options - ?�션 배열 [{ value, label }] ?�는 [string]
 *                                options가 ?�거??�?배열?�면 ?�일 체크박스 (체크?�면 "Y", 체크 ???�면 "N")
 *                                options가 ?�으�??�중 체크박스 (배열 반환)
 * @param {string} props.width - ?�드 ?�비
 * @param {string} props.labelWidth - ?�벨 ?�비
 * @param {string} props.fieldWidth - FormField ?�체 ?�비
 * @param {boolean} props.readonly - ?�기 ?�용 ?��?
 * @param {Function} props.onChange - �?변�??�들?? * @param {Object} props.fieldProps - 추�? ?�드 ?�성
 */
const CheckboxField = ({
  name,
  label,
  value = [],
  options = [],
  width,
  labelWidth,
  fieldWidth,
  showColon = false,
  readonly = false,
  onChange,
  fieldProps = {},
}) => {
  // options가 ?�거??�?배열?�면 ?�일 체크박스�?처리
  // 체크?�었?�면 "Y", 체크?��? ?�았?�면 "N" 반환
  const isSingle = !options || options.length === 0;
  
  if (isSingle) {
    // value가 "Y"?�면 체크?? �???"N" ?�는 �?문자???�면 체크 ????
    const isChecked = value === 'Y';
    
    const handleSingleCheckboxChange = (e) => {
      if (readonly || !onChange) return;
      
      // 체크?�면 "Y", 체크 ?�제?�면 "N" 반환
      const newValue = e.target.checked ? 'Y' : 'N';
      
      const syntheticEvent = {
        target: {
          name,
          value: newValue,
          checked: e.target.checked,
        },
      };
      onChange(syntheticEvent);
    };

    return (
      <FormField width={fieldWidth || 'auto'}>
        {label && (
          <FormFieldLabel width={labelWidth} >{showColon ? `${label}:` : label}</FormFieldLabel>
        )}
        <CheckboxGroup>
          <CheckboxOption disabled={readonly}>
            <input
              type="checkbox"
              name={name}
              checked={isChecked}
              disabled={readonly}
              onChange={handleSingleCheckboxChange}
              width={width || 'auto'}
              {...fieldProps}
            />
          </CheckboxOption>
        </CheckboxGroup>
      </FormField>
    );
  }

  // ?�중 체크박스??경우: options�??�용?�여 ?�러 ?�션 ?�더�?
  const valueArray = Array.isArray(value) ? value : (value ? [value] : []);

  // checkbox 변�??�들??
  const handleCheckboxChange = (optionValue, checked) => {
    if (readonly || !onChange) return;

    let newValue;
    if (checked) {
      // 체크??경우: 배열??추�?
      newValue = [...valueArray, optionValue];
    } else {
      // 체크 ?�제??경우: 배열?�서 ?�거
      newValue = valueArray.filter(v => v !== optionValue);
    }

    // ?�벤??객체�?만들?�서 onChange ?�출
    const syntheticEvent = {
      target: {
        name,
        value: newValue,
        checked: newValue.length > 0,
      },
    };
    onChange(syntheticEvent);
  };

  return (
    <FormField
      width={fieldWidth || 'auto'}
    >
      {label && (
        <FormFieldLabel width={labelWidth}>{showColon ? `${label}:` : label}</FormFieldLabel>
      )}
      <CheckboxGroup>
        {options.map((option) => {
          // options가 { value, label } ?�태??경우
          const optionValue = typeof option === 'object' && option.value !== undefined 
            ? option.value 
            : option;
          const optionLabel = typeof option === 'object' && option.label !== undefined 
            ? option.label 
            : option;
          
          const isChecked = valueArray.includes(optionValue);
          
          return (
            <CheckboxOption key={optionValue} disabled={readonly}>
              <input
                type="checkbox"
                name={name}
                value={optionValue}
                checked={isChecked}
                disabled={readonly}
                onChange={(e) => handleCheckboxChange(optionValue, e.target.checked)}
                width={width || 'auto'}
                {...fieldProps}
              />
              <span>{optionLabel}</span>
            </CheckboxOption>
          );
        })}
      </CheckboxGroup>
    </FormField>
  );
};

export default CheckboxField;

